import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Navbar from './components/Navbar';
import About from './components/About';
import Contact from "./components/Contact";
import BloodPressureChart from "./components/BloodPressureChart"

function App() {
  return (
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/navbar' element={<Navbar/>}/>
      <Route path='/about' element={<About/>}/>
      <Route path='/Contact' element={<Contact/>}/>
      <Route path='/BloodPressureChart' element={<BloodPressureChart/>}/>
    </Routes>
  );
}

export default App;
